export default "__VITE_ASSET__ErUag3jY__"